import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoDivider from '../../components/divider/pendo-divider.vue.js';
import PendoInputNumber from '../../components/input-number/pendo-input-number.vue.js';
import PendoRadio from '../../components/radio/pendo-radio.vue.js';
import PendoRadioGroup from '../../components/radio-group/pendo-radio-group.vue.js';

const WINDOW_SIZES = {
  mobile: {
    width: 350,
    height: 800
  },
  tablet: {
    width: 800,
    height: 1000
  }
};
var script = {
  name: 'PendoLaunchPreviewPane',
  components: {
    PendoDivider,
    PendoInputNumber,
    PendoRadio,
    PendoRadioGroup
  },
  props: {
    selectedWindowOption: {
      type: String,
      default: 'newTab'
    },
    selectedScreenSize: {
      type: String,
      default: 'mobile'
    },
    customHeight: {
      type: Number,
      default: 1200
    },
    customWidth: {
      type: Number,
      default: 800
    },
    hideSameTab: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      screenSizeOptions: [{
        value: 'mobile',
        label: `Mobile (${WINDOW_SIZES.mobile.width}x${WINDOW_SIZES.mobile.height})`
      }, {
        value: 'tablet',
        label: `Tablet (${WINDOW_SIZES.tablet.width}x${WINDOW_SIZES.tablet.height})`
      }, {
        value: 'custom',
        label: 'Custom'
      }]
    };
  },
  computed: {
    shouldShowScreenSize() {
      return this.selectedWindowOption === 'newWindow';
    },
    isCustomSelected() {
      return this.selectedScreenSize === 'custom';
    },
    windowOptions() {
      return [{
        value: 'newTab',
        label: 'New tab'
      }, !this.hideSameTab && {
        value: 'sameTab',
        label: 'Same tab'
      }, {
        value: 'newWindow',
        label: 'New window'
      }].filter(Boolean);
    }
  },
  methods: {
    getDesiredWindowSize(dimension, _ref) {
      let {
        selectedWindowOption,
        selectedScreenSize,
        customHeight,
        customWidth
      } = _ref;
      if (selectedWindowOption !== 'newWindow') {
        return;
      }
      if (selectedScreenSize === 'mobile') {
        return WINDOW_SIZES.mobile[dimension];
      }
      if (selectedScreenSize === 'tablet') {
        return WINDOW_SIZES.tablet[dimension];
      }
      return dimension === 'height' ? customHeight : customWidth;
    },
    emitUpdate(updates) {
      const updateEvent = _objectSpread2({
        selectedWindowOption: this.selectedWindowOption,
        selectedScreenSize: this.selectedScreenSize,
        customWidth: this.customWidth,
        customHeight: this.customHeight
      }, updates);
      updateEvent.height = this.getDesiredWindowSize('height', updateEvent);
      updateEvent.width = this.getDesiredWindowSize('width', updateEvent);
      this.$emit('update', updateEvent);
    },
    updateWindowOption(selectedWindowOption) {
      this.emitUpdate({
        selectedWindowOption
      });
    },
    updateScreenSize(selectedScreenSize) {
      this.emitUpdate({
        selectedScreenSize
      });
    },
    updateWidth(customWidth) {
      this.emitUpdate({
        customWidth
      });
    },
    updateHeight(customHeight) {
      this.emitUpdate({
        customHeight
      });
    }
  }
};

export { WINDOW_SIZES, script as default };
//# sourceMappingURL=pendo-launch-preview-pane.vue2.js.map
